module.exports = __webpack_public_path__ + "static/img/xingyeyingyong.dd9361f5.png";